"use client";

import { useState, useEffect } from "react";

export const useIsMobile = (breakpoint = 1024, isSimple?: boolean) => {
  // 1024px is typically 'lg' breakpoint
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth < breakpoint);
  }, []);

  useEffect(() => {
    if (!isSimple) {
      const checkIsMobile = () => {
        setIsMobile(window.innerWidth < breakpoint);
      };

      // Check initially
      checkIsMobile();

      // Add event listener
      window.addEventListener("resize", checkIsMobile);

      // Cleanup
      return () => window.removeEventListener("resize", checkIsMobile);
    }
  }, [breakpoint]);

  return isMobile;
};
